import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {PopinComponent} from "../../../components/popin/popin.component";
import {StockResponse} from "../../../services/api/stocks/model";
import {StockService} from "../../../services/api/stocks/stock.service";
import {format_price} from "../../../utils/helper";


@Component({
  selector: 'app-stocks-details-page',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatRow,
    MatRowDef,
    MatTable,
    NgForOf,
    NgIf,
    PopinComponent,
    ReactiveFormsModule,
    NgClass,
    MatHeaderCellDef
  ],
  templateUrl: './stocks-details-page.component.html',
  styleUrl: './stocks-details-page.component.css'
})
export class StocksDetailsPageComponent implements OnInit, OnChanges {
  stocksData: StockResponse[] = [];
  filterData: StockResponse[] = [];
  displayedColumns: string[] = [
    'item_name',
    'location_id',
    'production_date',
    'expiration_date',
    'actual_quantity',
    'item_id_add',
    'item_id_remove'
  ];

  tabContent = [
    {title: "Location 1", isSelected: true, filter: 1},
    {title: "Location 2", isSelected: false, filter: 2},
    {title: "Location 3", isSelected: false, filter: 3},
    {title: "Location 4", isSelected: false, filter: 4},
  ]

  appliedFilter: number = 1;
  selectedLocation: number = 1;

  @Input() refreshTable: boolean = false;
  @Output() sendItemToAdd: EventEmitter<StockResponse> = new EventEmitter<StockResponse>();
  @Output() sendItemRetire: EventEmitter<StockResponse> = new EventEmitter<StockResponse>();

  constructor(
    private stockService: StockService,
  ) {
  }

  ngOnInit() {
    this.getStocks();

  }

  ngOnChanges() {
    this.getStocks();
  }

  getStocks() {
    this.stockService.getStocks().subscribe(res => {
      this.stocksData = res;
      this.filterData = this.stocksData.sort((a, b) => a.item_name.localeCompare(b.item_name) || a.expiration_date.localeCompare(b.expiration_date));
    })
  }


  filterStocks(filter: number) {
    return this.filterData.filter(stock =>
      stock.location_id === filter);
  }

  selectTab(index: number) {
    this.appliedFilter = this.tabContent[index].filter;
    this.selectedLocation = this.tabContent[index].filter;
    this.tabContent.forEach((tab, i) => {
      tab.isSelected = i === index;
    });
  }


  searchResults(text: string) {
    this.filterData = text.trim() === ""
      ? this.stocksData
      : this.stocksData.filter(item => item?.item_name.toLowerCase().includes(text.toLowerCase()));
  }


  formatDateToMMDDYYYY(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  isExpirationAlerted(expirationDate: string | Date, threshold: number): boolean {
    const today = new Date();
    const expDate = new Date(expirationDate);

    // Calculate the difference in milliseconds
    const timeDifference = expDate.getTime() - today.getTime();

    // Calculate the difference in days
    const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    // Return true if the number of days is less than the threshold
    return dayDifference <= threshold;
  }

    protected readonly format_price = format_price;
}
